import React, {useState} from 'react';
import Page from './page';
import {useDispatch, useSelector} from 'react-redux';
import {navigateNext, setAgeGroup} from '../../action/actions';
import {publicBuildUrl} from '../../config/config';

const TargetGroup = () => {
    const [buttonAgeGroupOneHover, setButtonAgeGroupOneHover] = useState(false);
    const [buttonAgeGroupTwoHover, setButtonAgeGroupTwoHover] = useState(false);
    const dispatch = useDispatch();
    const {app: {room: {ageGroup}}} = useSelector((state) => state);

    const handleAgeGroup = (ageGroup) => {
        dispatch(setAgeGroup(ageGroup));
        dispatch(navigateNext());
    };

    return (
        <Page title={'Target Group Selection'}>
            <div className={'bodyContainer'}>
                <div onMouseEnter={() => setButtonAgeGroupOneHover(true)}
                     onMouseLeave={() => setButtonAgeGroupOneHover(false)}
                     onClick={() => handleAgeGroup(1)}
                     className={'bodyContainerColumn'}
                     style={{
                         ...styles.button,
                         backgroundImage: buttonAgeGroupOneHover || ageGroup === 1 ? `url("${publicBuildUrl}buttons/ButtonAgeGroup1.png")` : `url("${publicBuildUrl}buttons/ButtonAgeGroup1OnRollOver.png")`,
                         backgroundSize: 'min(100%, 727px)',
                         backgroundPosition: 'left center',
                     }}>
                    <div style={styles.buttonText}>10 - 13 jaar</div>
                </div>
                <div onMouseEnter={() => setButtonAgeGroupTwoHover(true)}
                     onMouseLeave={() => setButtonAgeGroupTwoHover(false)}
                     onClick={() => handleAgeGroup(2)}
                     className={'bodyContainerColumn'}
                     style={{
                         ...styles.button,
                         backgroundImage: buttonAgeGroupTwoHover || ageGroup === 2 ? `url("${publicBuildUrl}buttons/ButtonAgeGroup2.png")` : `url("${publicBuildUrl}buttons/ButtonAgeGroup2OnRollOver.png")`,
                         backgroundSize: 'min(100%, 727px)',
                         backgroundPosition: 'left center',
                     }}>
                    <div style={styles.buttonText}>Vanaf 13 jaar</div>
                </div>
            </div>
        </Page>
    );
}

const styles = {
    button: {
        cursor: 'pointer',
        aspectRatio: '702/291',
        backgroundRepeat: 'no-repeat',
    },
    buttonText: {
        color: '#ffffff',
        fontSize: '23px',
        fontWeight: 500,
        marginLeft: '25%'
    },
}
export default TargetGroup;
